exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.w-70[data-v-550d95f8]{\n    width: 70px !important;\n}\n.food-icon img[data-v-550d95f8]{\n  height: 80px;\n}\nlabel.radio .bx[data-v-550d95f8]{\n  font-size: 30px;\n}\ntr.highlight[data-v-550d95f8]{\n  height: 60px;\n}\n", ""]);

// exports
